<template>
    <div ref="baseAutoHorizonScrollMain" class="baseAutoHorizonScrollMain">
        <div
            :class="scrollClass"
            class="autoScrollContent"
            ref="autoScrollContent"
        >
            {{ text }}
        </div>
        <div :class="scrollClass" class="autoScrollContent" v-if="ifNeedScroll">
            {{ text }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseAutoHorizonScroll',

    props: {
        text: {
            type: String,
        },

        speed: {
            type: Number,
            default: 35,
        },
    },

    data() {
        return {
            scrollClass: '',

            ifNeedScroll: false,
        }
    },

    mounted() {
        this.init()
    },

    watch: {
        text()
        {
            this.$nextTick(() => {
                this.init();
            })
        }
    },

    methods: {
        init() {
            const baseAutoHorizonScrollMain = this.$refs
                .baseAutoHorizonScrollMain

            //
            if (
                baseAutoHorizonScrollMain.offsetWidth >=
                this.$refs.autoScrollContent.offsetWidth
            ) {
                return
            }
            
            //
            this.ifNeedScroll = true

            //
            this.scrollClass = this.setScrollStyle(
                this.$refs.autoScrollContent.offsetWidth / 2,
                this.speed
            )
        },

        setScrollStyle(offsetWidth, speed) {
            const uid = Math.random().toString(36).substr(2)
            const style = document.createElement('style')

            style.innerHTML = `@-webkit-keyframes rowup${uid} {
            0% {
                -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
            }
            100% {
                -webkit-transform: translate3d(-100%, 0, 0);
                transform: translate3d(-100%, 0, 0);
            }
        }
        @keyframes rowup${uid} {
            0% {
                -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
            }
            100% {
                -webkit-transform: translate3d(-100%, 0, 0);
                transform: translate3d(-100%, 0, 0);
            }
        }
        .rowup-${uid}{
            -webkit-animation: ${Math.floor(
                (offsetWidth * 1000) / speed
            )}ms rowup${uid} linear infinite normal;
            animation: ${Math.floor(
                (offsetWidth * 1000) / speed
            )}ms rowup${uid} linear infinite normal;
        }`

            //
            document.getElementsByTagName('head')[0].appendChild(style)

            //
            return `rowup-${uid}`
        },
    },
}
</script>

<style lang="scss" scoped>
.baseAutoHorizonScrollMain {
    width: 100%;
    white-space: nowrap;
    text-align: center;
    overflow: hidden;
    font-size: 0.12rem;
    line-height: 2em;
}

.autoScrollContent {
    display: inline-block;
    box-sizing: border-box;
    vertical-align: middle;
    padding: 0 $padding;
}

</style>